import { inject, Injectable } from '@angular/core';
import { OutgoingEventsHandlerService } from './outgoing-events-handler.service';
import { BaseParamsService } from '@app/core/base-params.service';
import { filter, map, startWith, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OutgoingEventsSenderService } from './outgoing-events/outgoing-events-sender.service';
import { EventTypes } from './outgoing-events/definitions/base-event';
import { VisitPlusAction } from './outgoing-events/definitions/visit-plus';
import { IncomingEventsHandlerService } from './incoming-events-handler.service';
import { IncomingEventsReceiverService } from './incoming-events/incoming-events-receiver.service';
import { IncomingEventTypes } from './incoming-events/definitions/base-event';

@Injectable({ providedIn: 'root' })
export class MobileAppIntegrationService {
  private readonly outgoingEventsHandlerService = inject(OutgoingEventsHandlerService);
  private readonly incomingEventsHandlerService = inject(IncomingEventsHandlerService);
  private readonly baseParamsService = inject(BaseParamsService);

  private readonly outgoingEventsSenderService = inject(OutgoingEventsSenderService);
  private readonly incomingEventsReceiverService = inject(IncomingEventsReceiverService);

  public init(): void {
    this.baseParamsService.getParamsResolvedObservable().pipe(
      map(() => this.baseParamsService.isInsideMobileApp()),
      filter(isInsideMobileApp => isInsideMobileApp),
      take(1)
    ).subscribe(() => {
      this.outgoingEventsHandlerService.register();
      this.incomingEventsHandlerService.register();
    });
  }

  public triggerCameraAccess(): void {
    this.outgoingEventsSenderService.send({ type: EventTypes.TriggerCameraAccess });
  }

  public sendVisitPlusEvent(action: VisitPlusAction): void {
    this.outgoingEventsSenderService.send({ type: EventTypes.VisitPlus, action });
  }

  public withRefreshOnEvent<T>(fetcher: () => Observable<T>): Observable<T> {
    return this.incomingEventsReceiverService.incomingEvents$.pipe(
      filter(event => event.type === IncomingEventTypes.RefreshData),
      startWith(null),
      switchMap(() => fetcher()),
    );
  }
}
